import { ExternalUser } from '../domain/ExternalUser'
import { ExternalUserFindResponse } from './find/dto/ExternalUserFindResponse'

export const externalUserModelFromResponse = (resUser: ExternalUserFindResponse): ExternalUser => ({ ...resUser })
